<template slot="OneClass">
  <div class="enrolment-step3-page px-4 py-4 md:px-5">
    <div class="mx-auto space-y-5">
      <section class="intro-card">
        <p class="mb-2 text-[15px] font-semibold text-slate-900">[{{ registSugang.getCompanyKoreanName() }} {{ registSugang.getSugangName() }}]</p>
        <p class="text-sm text-slate-600">
          수강신청기간 : {{ registSugang.getDisplayStartDate() }} ~ {{ registSugang.getDisplayEndDate() }} | 진행상태 :
          {{ registSugang.getStatus() }}
        </p>
      </section>

      <section class="intro-card">
        <p class="text-[15px] font-semibold text-slate-900">1:1 수강신청 등록</p>
      </section>

      <section class="section-card">
        <div class="toggle-group">
          <button
            type="button"
            :class="{
              'toggle-chip-active': registSugang.registSugangData.sugangSupType == '일반',
              'toggle-chip-inactive': registSugang.registSugangData.sugangSupType == '지원',
            }"
            class="toggle-chip"
            @click="registSugang.setSugangSupType('일반')"
          >
            일반
          </button>
          <button
            v-if="registSugang.registSugangInfo.isOneSup == 'Y'"
            type="button"
            :class="{
              'toggle-chip-active': registSugang.registSugangData.sugangSupType == '지원',
              'toggle-chip-inactive': registSugang.registSugangData.sugangSupType == '일반',
            }"
            class="toggle-chip"
            @click="registSugang.setSugangSupType('지원')"
          >
            지원
          </button>
        </div>
      </section>

      <section class="section-card">
        <OneClass
          :sugangOneLangList="registSugang.registSugangData.sugangOneLangList"
          :adult="'junior'"
          :adultText="'주니어'"
          @set-regist-sugang-junior-data="registSugang.setRegistSugangJuniorData"
        ></OneClass>
        <div class="section-action">
          <button type="button" class="secondary-action-button" @click="registSugang.registSugangOneClass('junior')">
            주니어 임시저장
          </button>
        </div>
      </section>

      <section v-if="registSugang.registMainSugangInfo.mainContent === 'adult'" class="section-card">
        <OneClassAult
          :sugangOneLangList="registSugang.registSugangData.sugangOneLangList"
          :adult="'adult'"
          :adultText="'성인'"
          @set-regist-sugang-adult-data="registSugang.setRegistSugangAdultData"
        ></OneClassAult>
        <div class="section-action">
          <button type="button" class="secondary-action-button" @click="registSugang.registSugangOneClass('adult')">
            성인 임시저장
          </button>
        </div>
      </section>

      <section class="section-card">
        <OneClassEduPay
          :sugangOneTimeInfo="registSugang.registSugangData.sugangOneTimeInfoList"
          @set-edupay-data="registSugang.setEduPayData"
        ></OneClassEduPay>
      </section>

      <section class="section-card">
        <p class="section-title">수업 유형 / 개월 수</p>
        <ul class="form-list">
          <li class="field-row field-row-start field-row-divider">
            <p class="field-label"><span class="font-bold text-red-500">*</span> 수업유형</p>
            <div class="field-content">
              <ul class="option-group">
                <li class="option-item">
                  <label class="option-label" for="chk5_0">
                    <input
                      type="checkbox"
                      name="chk5"
                      id="chk5_0"
                      true-value="Y"
                      false-value="N"
                      v-model="registSugang.registSugangData.isClassTypeMobile"
                    />
                    <span>전화</span>
                  </label>
                </li>
                <li class="option-item">
                  <label class="option-label" for="chk5_1">
                    <input
                      type="checkbox"
                      name="chk5"
                      id="chk5_1"
                      true-value="Y"
                      false-value="N"
                      v-model="registSugang.registSugangData.isClassTypePc"
                    />
                    <span>화상</span>
                  </label>
                </li>
                <li class="option-item">
                  <label class="option-label" for="chk5_2">
                    <input
                      type="checkbox"
                      name="chk5"
                      id="chk5_2"
                      true-value="N"
                      false-value="Y"
                      v-model="registSugang.registSugangData.isClassTypeView"
                    />
                    <span>노출안함</span>
                  </label>
                </li>
                <li class="option-hint">* 노출안함 선택 시 화상이 기본값으로 설정됩니다.</li>
              </ul>
            </div>
          </li>

          <li class="field-row">
            <p class="field-label"><span class="font-bold text-red-500">*</span> 개월 수</p>
            <div class="field-content">
              <ul class="option-group">
                <li class="option-item">
                  <label class="option-label" for="rdo1_0">
                    <input type="radio" name="rdo1" id="rdo1_0" value="0" v-model="registSugang.registSugangData.classMonth" />
                    <span>사용 안함</span>
                  </label>
                </li>
                <li class="option-item">
                  <label class="option-label" for="rdo1_1">
                    <input type="radio" name="rdo1" id="rdo1_1" value="1" v-model="registSugang.registSugangData.classMonth" />
                    <span>1개월</span>
                  </label>
                </li>
                <li class="option-item">
                  <label class="option-label" for="rdo1_2">
                    <input type="radio" name="rdo1" id="rdo1_2" value="2" v-model="registSugang.registSugangData.classMonth" />
                    <span>2개월</span>
                  </label>
                </li>
                <li class="option-item">
                  <label class="option-label" for="rdo1_3">
                    <input type="radio" name="rdo1" id="rdo1_3" value="3" v-model="registSugang.registSugangData.classMonth" />
                    <span>3개월</span>
                  </label>
                </li>
                <li class="option-item">
                  <label class="option-label" for="rdo1_4">
                    <input type="radio" name="rdo1" id="rdo1_4" value="4" v-model="registSugang.registSugangData.classMonth" />
                    <span>4개월</span>
                  </label>
                </li>
                <li class="option-item">
                  <label class="option-label" for="rdo1_5">
                    <input type="radio" name="rdo1" id="rdo1_5" value="5" v-model="registSugang.registSugangData.classMonth" />
                    <span>5개월</span>
                  </label>
                </li>
                <li class="option-item">
                  <label class="option-label" for="rdo1_6">
                    <input type="radio" name="rdo1" id="rdo1_6" value="6" v-model="registSugang.registSugangData.classMonth" />
                    <span>6개월</span>
                  </label>
                </li>
                <li class="option-item">
                  <label class="option-label" for="rdo1_7">
                    <input type="radio" name="rdo1" id="rdo1_7" value="12" v-model="registSugang.registSugangData.classMonth" />
                    <span>12개월</span>
                  </label>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </section>

      <section class="section-card">
        <p class="section-title">레벨테스트 신청 여부</p>
        <div class="field-row">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 레벨테스트 신청</p>
          <div class="field-content">
            <ul class="option-group">
              <li class="option-item">
                <label class="option-label" for="rdo2_0">
                  <input type="radio" name="rdo2" id="rdo2_0" value="Y" v-model="registSugang.registSugangData.isLevelTest" />
                  <span>사용</span>
                </label>
              </li>
              <li class="option-item">
                <label class="option-label" for="rdo2_1">
                  <input type="radio" name="rdo2" id="rdo2_1" value="N" v-model="registSugang.registSugangData.isLevelTest" />
                  <span>사용 안함</span>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section class="section-card">
        <p class="section-title">안내문구 입력</p>
        <ul class="form-list">
          <li class="field-row field-row-start field-row-divider">
            <div class="field-label field-label-check">
              <label class="checkbox-label" for="numberOfClassText">
                <input
                  type="checkbox"
                  id="numberOfClassText"
                  :checked="registSugang.registSugangData.isNumberOfClassText"
                  v-model="registSugang.registSugangData.isNumberOfClassText"
                  true-value="Y"
                  false-value="N"
                />
                <span>수업횟수 / 시간 안내</span>
              </label>
            </div>
            <div class="field-content">
              <textarea class="form-textarea" v-model="registSugang.registSugangData.numberOfClassText"></textarea>
            </div>
          </li>
          <li class="field-row field-row-start field-row-divider">
            <div class="field-label field-label-check">
              <label class="checkbox-label" for="hopeTimeText">
                <input
                  type="checkbox"
                  id="hopeTimeText"
                  :checked="registSugang.registSugangData.isHopeTimeText"
                  v-model="registSugang.registSugangData.isHopeTimeText"
                  true-value="Y"
                  false-value="N"
                />
                <span>희망 수업시간 안내</span>
              </label>
            </div>
            <div class="field-content">
              <textarea class="form-textarea" v-model="registSugang.registSugangData.hopeTimeText"></textarea>
            </div>
          </li>
          <li class="field-row field-row-start field-row-divider">
            <div class="field-label field-label-check">
              <label class="checkbox-label" for="levelChoiceText">
                <input
                  type="checkbox"
                  id="levelChoiceText"
                  :checked="registSugang.registSugangData.isLevelChoiceText"
                  v-model="registSugang.registSugangData.isLevelChoiceText"
                  true-value="Y"
                  false-value="N"
                />
                <span>레벨 선택 안내</span>
              </label>
            </div>
            <div class="field-content">
              <textarea class="form-textarea" v-model="registSugang.registSugangData.levelChoiceText"></textarea>
            </div>
          </li>
          <li class="field-row">
            <div class="field-label field-label-check">
              <span class="font-bold text-red-500">*</span>
              <span>교재 구입 여부</span>
            </div>
            <div class="field-content">
              <ul class="option-group">
                <li class="option-item">
                  <label class="option-label" for="rdo3_0">
                    <input type="radio" name="rdo3" id="rdo3_0" value="Y" v-model="registSugang.registSugangData.isBookBuy" />
                    <span>사용</span>
                  </label>
                </li>
                <li class="option-item">
                  <label class="option-label" for="rdo3_1">
                    <input type="radio" name="rdo3" id="rdo3_1" value="N" v-model="registSugang.registSugangData.isBookBuy" />
                    <span>사용 안함</span>
                  </label>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </section>

      <section class="action-card">
        <div class="action-row">
          <button type="button" class="secondary-action-button" @click="registSugang.goBack()">이전 페이지</button>

          <button
            type="button"
            class="primary-action-button"
            @click="registSugang.registSugangOneAll"
            v-if="registSugang.registSugangData.sugangSupType == '일반' && registSugang.registSugangInfo.isOneSup == 'Y'"
          >
            저장하고 1:1지원수강 작성하기
          </button>

          <button
            type="button"
            class="primary-action-button"
            @click="registSugang.registSugangOneAll"
            v-else-if="
              (registSugang.registSugangData.sugangSupType == `일반` &&
                registSugang.registSugangInfo.isOneSup == `N` &&
                registSugang.registSugangInfo.isGroup == `Y`) ||
              (registSugang.registSugangData.sugangSupType == `지원` && registSugang.registSugangInfo.isGroup == `Y`)
            "
          >
            저장하고 그룹수강 작성하기
          </button>

          <button type="button" class="primary-action-button" @click="registSugang.registSugangOneAll" v-else>
            완료하기
          </button>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import OneClass from "@/components/RegistOneClass.vue";
import OneClassAult from "@/components/RegistOneClassAdult.vue";
import OneClassEduPay from "@/components/RegistOneClassEduPay.vue";
import axios from "@/plugins/axios.js";
import { useStore } from "vuex";

export default {
  components: {
    OneClass,
    OneClassAult,
    OneClassEduPay,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const registSugang = reactive({
      // 홈페이지 정보
      registMainSugangInfo: {
        kname: "", // 한글이름
        mainContent: "", // 메인컨텐츠 유형 - junior: 주니어, adult: 주니어 + 성인 (20세 이상)
      },

      // 수강신청 메타 정보
      registSugangInfo: {
        isGroup: "N", //그룹 일반수강 사용여부값
        isGroupSup: "N", //그룹 지원수강 사용여부값
        isOne: "N", //1:1 일반수강 사용여부 값
        isOneSup: "N", //1:1 지원수강 사용여부 값

        startDate: "", // 시작일시
        endDate: "", // 종료일시
        status: "", // 진행 상태 - 예정, 진행중, 종료
      },

      registSugangData: {
        idxLeSugangOne: 0,
        idxLeSugang: 0,
        isClassTypeMobile: "N",
        isClassTypePc: "N",
        isClassTypeView: "N",
        classMonth: 0,
        isLevelTest: "",
        isNumberOfClassText: "N",
        isLevelChoiceText: "N",
        isHopeTimeText: "N",
        numberOfClassText: "",
        hopeTimeText: "",
        levelChoiceText: "",
        isBookBuy: "",
        sugangOneTimeInfo: [],
        sugangOneTimeInfoList: [],
        staffIdx: null,
        sugangOneLangList: [],
        sugangSupType: "일반", //일반, 지원 구분하는 값. 기본은 일반
        buttonName: "",
      },

      clearRegistSugangData() {
        registSugang.registSugangData = {
          ...registSugang.registSugangData,
          ...{
            isClassTypeMobile: "N",
            isClassTypePc: "N",
            isClassTypeView: "N",
            classMonth: 0,
            isLevelTest: "",
            isNumberOfClassText: "N",
            isLevelChoiceText: "N",
            isHopeTimeText: "N",
            numberOfClassText: "",
            hopeTimeText: "",
            levelChoiceText: "",
            isBookBuy: "",
            sugangOneTimeInfo: [],
            sugangOneTimeInfoList: [],
            staffIdx: null,
            sugangOneLangList: [],
            buttonName: "",
          },
        };
      },
      setSugangSupType(val) {
        router.push({
          name: "enrolmentStep3_1",
          query: {
            idxLeSugang: registSugang.registSugangData.idxLeSugang,
            sugangSupType: val,
          },
        });
      },

      setEduPayData(val) {
        registSugang.registSugangData.sugangOneTimeInfoList = val;
      },

      setRegistSugangJuniorData: (val) => {
        registSugang.registSugangData.sugangOneLangList = val;
      },

      setRegistSugangAdultData: (val) => {
        registSugang.registSugangData.sugangOneLangList = val;
      },

      getSugang() {
        // route.query.idxSugang 값이 존재하면 값을 가져오고, 아니라면 값을 비운다.
        if (registSugang.registSugangData.idxLeSugang > 0) {
          const params = {
            idxLeSugang: registSugang.registSugangData.idxLeSugang,
          };

          axios
            .get("/admin/sugang", {
              params: params,
            })
            .then(function (res) {
              if (res.data.success) {
                registSugang.registSugangInfo = { ...registSugang.registSugangInfo, ...res.data.data.sugangInfo };
                registSugang.registMainSugangInfo = res.data.data.siteMainInfo;
              }
            });
        }
      },

      // 1:1 수강 언어 선택 및 저장
      getOneClass() {
        //route.query.idxSugang 값이 존재하면 값을 가져오고, 아니라면 값을 비운다.
        if (registSugang.registSugangData.idxLeSugang > 0) {
          const params = {
            idxLeSugang: registSugang.registSugangData.idxLeSugang,
            sugangSupType: registSugang.registSugangData.sugangSupType,
          };

          axios.get("/admin/sugangOne", { params: params }).then(function (res) {
            if (res.data.success) {
              registSugang.registSugangData = { ...registSugang.registSugangData, ...res.data.data };
              // 초기값 로드 후 수업유형 체크박스 상태 동기화
              // 1. 노출안함이 N이면 전화/화상을 N으로 설정
              // 2. 전화/화상이 Y면 노출안함을 Y로 설정
              registSugang.handleClassTypeViewChange(registSugang.registSugangData.isClassTypeView);
              registSugang.handleClassTypeMobilePcChange();
            }
          });
        }
      },

      // 수강신청
      registSugangOneAll() {
        const params = registSugang.registSugangData;
        axios.post("/admin/sugangOneAll", params, {}).then(function (res) {
          if (res.data.success) {
            //일반과 그룹이 함께 존재하는 경우, 일반을 우선 저장하도록 유도해야 오류가 적을 수 있다.
            //일반을 저장하는 경우, 지원이 존재하면 지원으로 이동된다.
            if (registSugang.registSugangData.sugangSupType == "일반" && registSugang.registSugangInfo.isOneSup == "Y") {
              registSugang.setSugangSupType("지원");
            } else if (
              (registSugang.registSugangData.sugangSupType == "일반" &&
                registSugang.registSugangInfo.isOneSup == "N" &&
                registSugang.registSugangInfo.isGroup == "Y") ||
              (registSugang.registSugangData.sugangSupType == "지원" && registSugang.registSugangInfo.isGroup == "Y")
            ) {
              //지원을 저장하는 경우, 그룹이 존재하면 그룹으로 이동한다.
              alert("1:1 수강신청을 등록 완료하였습니다. 그룹 수강신청으로 이동합니다.");
              router.push({
                name: "enrolmentStep3_2",
                query: {
                  idxLeSugang: registSugang.registSugangData.idxLeSugang,
                },
              });
            } else {
              alert("1:1 수강신청을 등록 완료하였습니다.");
              router.push({ path: "/home" });
            }
          } else {
            alert(res.data.message);
          }
          // listPage.is_loader = false;
        });
      },

      // 수강신청
      registSugangOneClass(adultType) {
        let sugangOneLangListParam = registSugang.registSugangData.sugangOneLangList.filter((item) => item.adult == adultType);

        const params = {
          adult: adultType,
          idxLeSugang: registSugang.registSugangData.idxLeSugang,
          idxLeSugangOne: registSugang.registSugangData.idxLeSugangOne,
          sugangSupType: registSugang.registSugangData.sugangSupType,
          buttonName: "",
          staffIdx: store.state.staffInfo.idx,
          sugangOneLangList: sugangOneLangListParam,
        };
        axios.post("/admin/sugangOne", params, {}).then(function (res) {
          if (res.data.success) {
            alert("수강신청 과정 저장 완료");
            // 저장하게되면 되돌려받는 le_sugang_one 값을 갱신해주어야 한다.
            registSugang.registSugangData.idxLeSugangOne = res.data.data.idxLeSugangOne;
          } else {
            alert(res.data.message);
          }
        });
      },

      goBack() {
        if (!confirm("작업 내용이 저장되지 않습니다. 이전 페이지로 이동하시겠습니까?")) {
          return;
        }

        // 이전페이지의 동작은 무조건 histroy.back 로 한다.
        router.push({ path: "/enrolmentStep2", query: { idxLeSugang: registSugang.registSugangData.idxLeSugang } });
      },

      // 수강신청 홈페이지 정보
      getSugangHomepageInfo() {
        return this.registMainSugangInfo;
      },

      // 회사명
      getCompanyKoreanName() {
        const { kname } = this.getSugangHomepageInfo();
        return kname;
      },

      // 수강신청 정보
      getSugangInfo() {
        return this.registSugangInfo;
      },

      // 과정명
      getSugangName() {
        const { sugangName } = this.getSugangInfo();
        return sugangName;
      },

      // 수강신청기간 시작일시 표시 메서드
      getDisplayStartDate() {
        const { startDate } = this.getSugangInfo();

        if (!startDate) return;

        const [date, time] = startDate.split(" ");
        const [hour, minute] = time.split(":");
        return this.formatDate(date, hour, minute);
      },

      // 수강신청기간 종료일시 표시 메서드
      getDisplayEndDate() {
        const { endDate } = this.getSugangInfo();

        if (!endDate) return;

        const [date, time] = endDate.split(" ");
        const [hour, minute] = time.split(":");
        return this.formatDate(date, hour, minute);
      },

      formatDate(date, hour, minute) {
        return `${date} ${hour}:${minute}`;
      },

      // 수강신청 진행상태
      getStatus() {
        const { status } = this.getSugangInfo();

        if (!status) return "";
        return status;
      },

      // 노출안함 값 변경 시 전화/화상 값 처리
      handleClassTypeViewChange(newValue) {
        if (newValue === "N") {
          // 노출안함이 체크된 경우 (값이 N) 전화, 화상을 N으로 설정
          registSugang.registSugangData.isClassTypeMobile = "N";
          registSugang.registSugangData.isClassTypePc = "N";
        }
      },

      // 전화/화상 값 변경 시 노출안함 값 처리
      handleClassTypeMobilePcChange() {
        // 전화나 화상이 하나라도 Y라면 노출안함은 Y(체크해제)가 되어야 함
        if (registSugang.registSugangData.isClassTypeMobile === "Y" || registSugang.registSugangData.isClassTypePc === "Y") {
          registSugang.registSugangData.isClassTypeView = "Y";
        }
      },
    });

    // 노출안함 값 변경 감지
    watch(
      () => registSugang.registSugangData.isClassTypeView,
      (newValue) => {
        registSugang.handleClassTypeViewChange(newValue);
      }
    );

    // 전화 값 변경 감지: Y가 되면 노출안함을 Y로 설정
    watch(
      () => registSugang.registSugangData.isClassTypeMobile,
      () => {
        registSugang.handleClassTypeMobilePcChange();
      }
    );

    // 화상 값 변경 감지: Y가 되면 노출안함을 Y로 설정
    watch(
      () => registSugang.registSugangData.isClassTypePc,
      () => {
        registSugang.handleClassTypeMobilePcChange();
      }
    );

    onMounted(() => {
      if (route.query.idxLeSugang) {
        registSugang.registSugangData.idxLeSugang = Number(route.query.idxLeSugang);
        registSugang.registSugangData.sugangSupType = "일반";
        if (route.query.sugangSupType && route.query.sugangSupType == "지원") {
          registSugang.registSugangData.sugangSupType = "지원";
        }

        registSugang.getSugang();
        registSugang.getOneClass();
      } else {
        alert("잘못된 접근입니다.");
        router.push({ path: "/home" });
      }
    });

    return {
      registSugang,
    };
  },
};
</script>
<style scoped>
.enrolment-step3-page {
  min-height: 100%;
  background:
    radial-gradient(circle at top left, rgba(226, 232, 240, 0.65), transparent 32rem),
    linear-gradient(180deg, #f8fafc 0%, #ffffff 42%);
}

.intro-card,
.section-card,
.action-card {
  margin: 0 auto;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  padding: 1.25rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.section-title {
  margin-bottom: 1rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #e2e8f0;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.toggle-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.toggle-chip {
  border: 1px solid #cbd5e1;
  border-radius: 9999px;
  padding: 0.7rem 1rem;
  font-size: 0.9rem;
  font-weight: 700;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
}

.toggle-chip-active {
  border-color: #0f172a;
  background: #0f172a;
  color: #fff;
}

.toggle-chip-inactive {
  background: #fff;
  color: #475569;
}

.section-action {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.form-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.field-row-start {
  align-items: flex-start;
}

.field-row-divider {
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.field-label {
  flex: none;
  width: 9rem;
  padding-top: 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
}

.field-label-check {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding-top: 0.25rem;
  width: 12rem;
}

.field-content {
  flex: 1;
  min-width: 0;
}

.option-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.option-item {
  list-style: none;
}

.option-label {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 2.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background: #f8fafc;
  padding: 0.7rem 1rem;
  font-size: 0.9rem;
  color: #334155;
  cursor: pointer;
}

.option-hint {
  display: flex;
  align-items: center;
  min-height: 2.875rem;
  font-size: 0.8125rem;
  color: #64748b;
}

.checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  white-space: nowrap;
}

.form-textarea {
  width: 100%;
  max-width: 42rem;
  min-height: 7.5rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.85rem 0.95rem;
  font-size: 0.95rem;
  color: #0f172a;
  resize: vertical;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.form-textarea:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}

.action-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.secondary-action-button,
.primary-action-button {
  display: inline-flex;
  min-height: 2.875rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  padding: 0.7rem 1rem;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.secondary-action-button {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #475569;
}

.secondary-action-button:hover {
  background: #f8fafc;
}

.primary-action-button {
  border: 1px solid #2563eb;
  background: #2563eb;
  color: #fff;
}

.primary-action-button:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;
}

.enrolment-step3-page input[type="radio"],
.enrolment-step3-page input[type="checkbox"] {
  accent-color: #2563eb;
}

@media (max-width: 1023px) {
  .field-row,
  .action-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .field-label {
    width: 100%;
    padding-top: 0;
  }

  .secondary-action-button,
  .primary-action-button {
    width: 100%;
  }
}
</style>
